export default "__VITE_ASSET__462cf93f__$_?component__"